import './sass/index.scss';

import App from './App';
import Backend from 'i18next-http-backend';
import { DateTime } from 'luxon';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { environment } from './environment';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import reportWebVitals from './reportWebVitals';

console.log(environment());
const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement,
);
const lng = new URLSearchParams(window.location.search).get('lang') || 'en';
localStorage.setItem('lang', lng);

i18n
	.use(Backend)
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		lng,
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false,
			format: (value, format, lng) => {
				// legacy usage
				if (value instanceof Date) {
					return DateTime.fromJSDate(value)
						.setLocale(lng!)
						.toLocaleString((DateTime as any)[format!]);
				}
				return value;
			},
		},
	})
	.then(() => {
		root.render(
			<React.StrictMode>
				<App />
			</React.StrictMode>,
		);
	});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
